/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for ProductResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetProductByIdResponse, ProductType, GetProductsResponse, GetProductSelectResponse } from "../models";

@Injectable({ providedIn: "root" })
export class ProductResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getProductById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetProductByIdResponse, unknown> & { defaultValue: NoInfer<GetProductByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetProductByIdResponse>;
    getProductById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetProductByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetProductByIdResponse | undefined>;
    getProductById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetProductByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetProductByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Product/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getProducts(searchTerm: Signal<string | null | undefined> | string | null | undefined, type: Signal<(Array<ProductType> | null) | undefined> | (Array<ProductType> | null) | undefined, legalEntityIds: Signal<(Array<number> | null) | undefined> | (Array<number> | null) | undefined, resourceOptions: HttpResourceOptions<GetProductsResponse, unknown> & { defaultValue: NoInfer<GetProductsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetProductsResponse>;
    getProducts(searchTerm?: Signal<string | null | undefined> | string | null, type?: Signal<(Array<ProductType> | null) | undefined> | (Array<ProductType> | null), legalEntityIds?: Signal<(Array<number> | null) | undefined> | (Array<number> | null), resourceOptions?: HttpResourceOptions<GetProductsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetProductsResponse | undefined>;
    getProducts(searchTerm?: Signal<string | null | undefined> | string | null, type?: Signal<(Array<ProductType> | null) | undefined> | (Array<ProductType> | null), legalEntityIds?: Signal<(Array<number> | null) | undefined> | (Array<number> | null), resourceOptions?: HttpResourceOptions<GetProductsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetProductsResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const searchTermValue = typeof searchTerm === 'function' ? searchTerm() : searchTerm;
            if (searchTermValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, searchTermValue, 'searchTerm');
            }
            const typeValue = typeof type === 'function' ? type() : type;
            if (typeValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, typeValue, 'type');
            }
            const legalEntityIdsValue = typeof legalEntityIds === 'function' ? legalEntityIds() : legalEntityIds;
            if (legalEntityIdsValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, legalEntityIdsValue, 'legalEntityIds');
            }
            return {
                url: `${this.basePath}/Product`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getProductSelect(searchTerm: Signal<string | null | undefined> | string | null | undefined, type: Signal<(Array<ProductType> | null) | undefined> | (Array<ProductType> | null) | undefined, legalEntityIds: Signal<(Array<number> | null) | undefined> | (Array<number> | null) | undefined, resourceOptions: HttpResourceOptions<GetProductSelectResponse, unknown> & { defaultValue: NoInfer<GetProductSelectResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetProductSelectResponse>;
    getProductSelect(searchTerm?: Signal<string | null | undefined> | string | null, type?: Signal<(Array<ProductType> | null) | undefined> | (Array<ProductType> | null), legalEntityIds?: Signal<(Array<number> | null) | undefined> | (Array<number> | null), resourceOptions?: HttpResourceOptions<GetProductSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetProductSelectResponse | undefined>;
    getProductSelect(searchTerm?: Signal<string | null | undefined> | string | null, type?: Signal<(Array<ProductType> | null) | undefined> | (Array<ProductType> | null), legalEntityIds?: Signal<(Array<number> | null) | undefined> | (Array<number> | null), resourceOptions?: HttpResourceOptions<GetProductSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetProductSelectResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const searchTermValue = typeof searchTerm === 'function' ? searchTerm() : searchTerm;
            if (searchTermValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, searchTermValue, 'searchTerm');
            }
            const typeValue = typeof type === 'function' ? type() : type;
            if (typeValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, typeValue, 'type');
            }
            const legalEntityIdsValue = typeof legalEntityIds === 'function' ? legalEntityIds() : legalEntityIds;
            if (legalEntityIdsValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, legalEntityIdsValue, 'legalEntityIds');
            }
            return {
                url: `${this.basePath}/Product/Select`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
